import { Provider } from "@angular/core";
import type { ProvideFiltersOptions } from "./filter.types";
import { FilterService } from "./filter.service";
import { FilterRegistrationResolver } from "./filter-registration.resolver";
import { VIEW_TYPE } from "./filter.tokens";
import { FILTER_PROVIDERS } from "./filters";
import { FilterPersistence, FilterRegistry, FilterStore } from "./store";

export function provideFilters(options: ProvideFiltersOptions, providers: Provider[] = []): Provider[] {
    return [
        ...providers,
        FilterPersistence,
        FilterRegistry,
        FilterStore,
        FilterService,
        FilterRegistrationResolver,

        ...FILTER_PROVIDERS,

        {
            provide: VIEW_TYPE,
            useValue: options.viewType,
        },
    ];
}
